/**
 * AuthLayout.tsx — components/layouts/AuthLayout.tsx
 * Exporta: default export
 */
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AuthPageSkeleton } from "@/components/common/routeFallback/AuthPageSkeleton";
import { SAFE_AREA } from "@/lib/nativeShell";
import SeoHead from "@/components/seo/SeoHead";

/**
 * Layout para páginas de autenticación (Login/Register)
 */
const AuthLayout = () => {
  return (
    <div
      className={`${SAFE_AREA.authShell} bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex items-center justify-center p-4 transition-colors duration-200 overflow-y-auto`}
      style={{ minHeight: "100dvh" }}
    >
      <SeoHead
        title="ALTENOT — Acceso"
        description="Inicia sesión o regístrate en ALTENOT, el sistema de control total para tu negocio."
        robots="noindex, nofollow"
      />
      <div className="w-full max-w-md">
        <Suspense fallback={<AuthPageSkeleton />}>
          <Outlet />
        </Suspense>
        <p className="text-center text-primary-200/60 dark:text-slate-500 text-xs mt-6">
          © {new Date().getFullYear()} Altenot Tech · Todos los derechos
          reservados
        </p>
      </div>
    </div>
  );
};

export default AuthLayout;
